
  import { Box } from '@/ui/components/Box';
  import DarkContactUs from '@/ui/components/button/DarkContactUs.vue';
  import { defineComponent } from 'vue';

  export default defineComponent({
    components: { Box, DarkContactUs },
    props: {
      message: {
        type: String,
        required: true,
      },
    },
  });
